import React from "react";
import * as sharedStyled from "../../styled";
import logo from "../../../../resources/bluedot-logo.png";
import BackwardsNavigation from "../../../BackNavigation";
import * as styled from "./styled";

export default ({ error, onClickBack }) => {
  const renderSupportTeamLinkIfPresent = (supportMessage) => {
    const contactSupportTeamKey = "Support Team";
    const supportMessageIndex = supportMessage.indexOf(contactSupportTeamKey);
    if (supportMessageIndex >= 0) {
      const beforeSupportMessageSection = supportMessage.slice(
        0,
        supportMessageIndex
      );
      const afterSupportMesssageSection = supportMessage.slice(
        supportMessageIndex + contactSupportTeamKey.length
      );
      return (
        <p>
          {beforeSupportMessageSection}{" "}
          <a
            href="https://bluedotinnovation.zendesk.com/hc/en-us"
            target="_blank"
            rel="noopener noreferrer"
          >
            Support Team
          </a>{" "}
          {afterSupportMesssageSection}
        </p>
      );
    }
    return <p>{supportMessage}</p>;
  };

  return (
    <sharedStyled.Container>
      <div>
        <BackwardsNavigation onClick={onClickBack} />
        <sharedStyled.MainContentContainer>
          <sharedStyled.Logo src={logo} alt="logo" />
          <h1>{error.title}</h1>
          <p>{error.message}</p>
          <styled.SupportMessageContainer>
            {renderSupportTeamLinkIfPresent(error.supportMessage)}
          </styled.SupportMessageContainer>
        </sharedStyled.MainContentContainer>
      </div>
    </sharedStyled.Container>
  );
};
